import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Ensures an order ID is in UUID format with dashes (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx).
 * If the ID is 32 hex chars without dashes, adds them. Otherwise returns as-is.
 */
export function formatOrderId(id: string | null | undefined): string | null {
  if (!id || typeof id !== "string") return null;
  const trimmed = id.trim();
  if (!trimmed) return null;
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(trimmed)) {
    return trimmed;
  }
  const noDashes = trimmed.replace(/-/g, "");
  if (/^[0-9a-f]{32}$/i.test(noDashes)) {
    return `${noDashes.slice(0, 8)}-${noDashes.slice(8, 12)}-${noDashes.slice(12, 16)}-${noDashes.slice(16, 20)}-${noDashes.slice(20, 32)}`;
  }
  return trimmed;
}
